// MV Adventure - Animaciones PRO (JS)
(function () {
  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Fade-in al hacer scroll usando IntersectionObserver
  function initScrollFade() {
    if (prefersReduced) return;

    var targets = document.querySelectorAll(
      '.shopify-section, .card, .product-card, .collection-card, .scroll-fade'
    );
    if (!targets.length) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );

    targets.forEach(function (el) {
      observer.observe(el);
    });
  }

  // Header que reacciona al hacer scroll
  function initHeaderScroll() {
    var lastState = false;
    function onScroll() {
      var scrolled = window.scrollY > 40;
      if (scrolled !== lastState) {
        document.body.classList.toggle('scrolled', scrolled);
        lastState = scrolled;
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function init() {
    initScrollFade();
    initHeaderScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Reinicializa tras cambios del theme editor
  document.addEventListener('shopify:section:load', initScrollFade);
})();
